import { Injectable } from '@angular/core';
import { LandingModelService } from './landingModel.service';
import { MediaPictureService } from "./media-picture.service";
import { Device } from '../model/Device';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  constructor(private mediaPictureService: MediaPictureService, private landingModelService: LandingModelService) {
  }

  resolveBackgroundModule(module: any, device: Device) {
    let styles = {} as Record<string, string>;
    const backgroundModule = [module, module.data].map(x => x?.background_module).find(x => x?.color || x?.image || x?.css_options);
    if (backgroundModule) {
      if (backgroundModule.color) {
          styles['background-color'] = backgroundModule?.color;
          if(backgroundModule.type === "CONTENT_WIDTH") {
            styles['overflow'] = 'hidden';
            styles['border-radius'] = '8px';
            styles['padding'] = device.type === 'MOBILE' ? '30px 16px 16px 16px' : '24px 32px';
            styles['display'] = 'block';
          }

      } else if (backgroundModule.css_options != null) {
          styles = {...styles, ...backgroundModule.css_options};

      } else {
        styles.background = 'url(' + this.mediaPictureService.getMediaUrl(backgroundModule?.image) + ')';
        styles['background-size'] = 'cover';
        styles['background-repeat'] = 'round';
      }
      
    } else if (module.background_color) {
      styles['background-color'] = 'var(' + module?.background_color + ')';
    }

    return styles;
  }

  isRestrictResources(moduleId: string) {
    return this.landingModelService.getLandingModel().modulesResourcesRestricted?.includes('*') 
        || this.landingModelService.getLandingModel().modulesResourcesRestricted?.includes(moduleId);
  }

  onElementVisible(
    nativeElement: HTMLElement,
    callback: (entry: IntersectionObserverEntry) => void,
    onlyOnce = true,
    observerProps: IntersectionObserverInit = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    }
  ) {
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            callback(entry);
            if (onlyOnce) observer.disconnect();
          }
        });
      },
      observerProps
    );
  
    observer.observe(nativeElement);
  }
}
